<template>
  <div>
    <div class="radio-container-pc">
      <div v-if="validator && !isDisabled" class="validator-line">
        {{ TUITranslateService.t("AIDesk.请填写必填项") }}
      </div>
      <div :class="['form-radio-box-pc',isDisabled ? 'form-radio-box-pc-disabled' : '']" v-for="(item,index) in chooseItemList" :key="index">
        <div class="radio-container-pc-icon" @click="clickItem(index)">
          <div class="radio-icon">
            <img :src="changeSelectedIcon(item)" alt="" style="width: 20px; height: 20px; vertical-align: middle;"/>
          </div>
          <div class="radio-label">
            {{ item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import vue from '../../../../../../../../adapter-vue';
import radioUncheckIcon from '../../../../../../../../assets/radio-uncheck.png';
import radioCheckIcon from '../../../../../../../../assets/radio-check.png';
import { TUITranslateService } from '../../../../../../../../@aidesk/uikit-engine';
const { ref } = vue;
export default {
  props: {
    chooseItemList: {
      type: Array,
      default: []
    },
    name: {
      type: String,
      default: '',
    },
    isRequired: {
      type: Number,
      default: 0,
    },
    validator: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits:['input-change'],
  setup(props,{emit}){
    const selectedOption = ref<string>('');
    const checkedIcon = ref<string>('');
    const changeSelectedIcon = (name:any) => {
      if (selectedOption.value === name) {
        return radioCheckIcon;
      } else {
        return radioUncheckIcon;
      }
    }

    const clickItem=(index:number) => {
      if (props.isDisabled) {
        return;
      }
      selectedOption.value = props.chooseItemList[index] as string;
      emit('input-change',{name:props.name,value:selectedOption.value});
    }

    const onInputChanged = ():void => {
      emit('input-change',{name:props.name,value:selectedOption.value});
    };
    return {
      onInputChanged,
      selectedOption,
      clickItem,
      radioUncheckIcon,
      radioCheckIcon,
      changeSelectedIcon,
      checkedIcon,
      TUITranslateService
    }
  }
}
</script>
<style lang="scss">
.form-radio-box{
  margin-bottom: 5px;
}
.radio-container-pc {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.form-radio-box-pc {
  padding: 5px 0;
}
.form-radio-box-pc-disabled {
  color: #b0b0b0;
}
.radio-container-pc-icon {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  .radio-icon {
    margin-right:5px;
  }
}
</style>
